import { SeeqNames } from '@seeqdev/constants';

export const getLockingChannel = (workbookId: string) => [SeeqNames.Channels.LockingChannel, workbookId];
